const BASE = "/assets/agm/global-presence";
const PUBLIC_LIFE_BASE = "/assets/agm/public-life";

export const publicLeadershipMoments = [
  {
    category: "National leadership",
    eyebrow: "Public trust",
    title: "A trusted spiritual presence in national life.",
    text:
      "Dialogues with national leadership help new visitors understand Swami ji's public stature. AGM uses that trust to invite disciplined participation in healthcare, education, dignity and relief seva.",
    image: `${PUBLIC_LIFE_BASE}/pm-modi-swamiji-dialogue.jpg`,
    featureImage: `${PUBLIC_LIFE_BASE}/pm-modi-swamiji-seated-dialogue.jpg`,
    alt: "Pujya Swami Avdheshanand Giri ji in dialogue with Prime Minister Narendra Modi",
    featureAlt: "Pujya Swami Avdheshanand Giri ji seated in dialogue with Prime Minister Narendra Modi",
    featureAspect: "16 / 9",
    featureImageFit: "contain",
    featureObjectPosition: "center",
    objectPosition: "center",
  },
  {
    category: "Rashtrapati Bhavan",
    eyebrow: "Civic recognition",
    title: "A spiritual voice received with respect across public institutions.",
    text:
      "Such moments establish credibility for audiences who may be discovering Swami ji for the first time, while AGM keeps the next step clear: support measurable seva.",
    image: `${PUBLIC_LIFE_BASE}/president-of-india-meeting-v2.jpg`,
    alt: "Pujya Swami Avdheshanand Giri ji meeting the President of India",
    objectPosition: "center top",
  },
  {
    category: "State leadership",
    eyebrow: "Public service dialogue",
    title: "Spiritual leadership in conversation with state and civic leaders.",
    text:
      "These images act as trust bridges: respected public relationships that strengthen the mission's ability to mobilize people for social upliftment.",
    image: `${PUBLIC_LIFE_BASE}/yogi-adityanath-meeting-v2.jpg`,
    alt: "Pujya Swami Avdheshanand Giri ji with Uttar Pradesh public leadership",
    objectPosition: "center top",
  },
  {
    category: "National forums",
    eyebrow: "Cultural leadership",
    title: "Dharma, culture and public responsibility meeting on one platform.",
    text:
      "Public forums allow Swami ji's Vedantic guidance to reach civic, cultural and administrative audiences, turning respect into a broader call for service.",
    image: `${PUBLIC_LIFE_BASE}/public-dialogue-sangh.jpg`,
    alt: "Pujya Swami Avdheshanand Giri ji in conversation with public and cultural leadership",
    objectPosition: "center",
  },
  {
    category: "Seva context",
    eyebrow: "Dharmic stewardship",
    title: "Seva includes care for living traditions and all beings.",
    text:
      "Gaushala and dharmic stewardship imagery helps connect Vedantic compassion with daily responsibility, humility and care.",
    image: `${PUBLIC_LIFE_BASE}/gaushala-seva.jpg`,
    alt: "Pujya Swami Avdheshanand Giri ji feeding cows in a gaushala",
    objectPosition: "center",
  },
];

export const globalPresenceHighlights = [
  {
    eyebrow: "U.S. public presence",
    place: "Times Square, New York",
    title: "Yoga and Vedantic wellness in the public square.",
    text:
      "Swami ji's presence at Times Square gives U.S. audiences an immediate entry point: yoga, inner discipline and service are not separate paths, but one public ethic.",
    image: `${BASE}/times-square-yoga-day.jpg`,
    alt: "Pujya Swami Avdheshanand Giri ji with community members at International Yoga Day in Times Square",
    objectPosition: "center",
  },
  {
    eyebrow: "Global harmony",
    place: "Interfaith dialogue",
    title: "Dialogue across traditions, rooted in respect.",
    text:
      "AGM can present Swami ji's global spiritual presence as a bridge: Vedant deepens identity while widening compassion toward every community.",
    image: `${BASE}/interfaith-sankalp.jpg`,
    alt: "Pujya Swami Avdheshanand Giri ji with leaders from multiple faith traditions",
    objectPosition: "center 35%",
  },
  {
    eyebrow: "Public life",
    place: "National leadership",
    title: "A spiritual voice trusted in civic spaces.",
    text:
      "Swami ji's engagement with public leaders reflects a wider trust in his guidance, while AGM keeps its focus on measurable seva outcomes.",
    image: `${BASE}/president-of-india-meeting.jpg`,
    alt: "Pujya Swami Avdheshanand Giri ji meeting national public leadership",
    objectPosition: "center top",
  },
  {
    eyebrow: "Seva infrastructure",
    place: "Healthcare guidance",
    title: "Spiritual inspiration supporting modern service institutions.",
    text:
      "The same guidance that speaks of oneness also supports practical care: clinics, equipment, partnerships and health access for people in need.",
    image: `${BASE}/hospital-equipment-guidance.jpg`,
    alt: "Pujya Swami Avdheshanand Giri ji viewing healthcare equipment with medical professionals",
    objectPosition: "center",
  },
];

export const lineageMoments = [
  {
    eyebrow: "Guru-parampara",
    title: "Lineage gives service its inner discipline.",
    text:
      "AGM's seva is anchored in guru-parampara, sannyas dharma and Vedantic responsibility: service offered with humility, discipline and reverence.",
    image: `${BASE}/guru-parampara-bharat-mata-mandir.jpg`,
    alt: "Pujya Swami Avdheshanand Giri ji with his Guru in a guru-parampara setting",
    objectPosition: "center",
  },
  {
    eyebrow: "Monastic fraternity",
    title: "Sadhus and acharyas hold a living tradition.",
    text:
      "Sannyas and sadhu gatherings reveal the spiritual discipline behind public seva: a life trained toward restraint, responsibility and service.",
    image: `${BASE}/sannyas-home-haridwar.jpg`,
    alt: "Sadhus gathered with Pujya Swami Avdheshanand Giri ji in Haridwar",
    objectPosition: "center",
  },
  {
    eyebrow: "Sacred institutions",
    title: "Bharat Mata Mandir and sacred memory.",
    text:
      "Bharat Mata Mandir connects Vedantic wisdom, national cultural memory and social duty, reminding visitors that devotion must also protect society.",
    image: `${BASE}/bharat-mata-mandir-lineage.jpg`,
    alt: "Pujya Swami Avdheshanand Giri ji with saints at Bharat Mata Mandir",
    objectPosition: "center",
  },
  {
    eyebrow: "Pilgrimage dharma",
    title: "Sacred geography becomes social responsibility.",
    text:
      "Pilgrimage imagery can lead visitors toward AGM's relief work, health camps, food seva and dignity-centered care for pilgrims.",
    image: `${BASE}/amarnath-darshan.jpg`,
    alt: "Pujya Swami Avdheshanand Giri ji at Amarnath with devotees and attendants",
    objectPosition: "center",
  },
];

export const globalPresenceGallery = [
  {
    category: "United States",
    label: "Times Square Yoga Day gathering",
    image: `${BASE}/times-square-yoga-day.jpg`,
    alt: "Community yoga gathering with Pujya Swami Avdheshanand Giri ji at Times Square",
  },
  {
    category: "United States",
    label: "Solstice in Times Square stage",
    image: `${BASE}/times-square-yoga-stage.jpg`,
    alt: "Pujya Swami Avdheshanand Giri ji speaking from a Times Square stage",
  },
  {
    category: "Global harmony",
    label: "Interfaith and environmental sankalp",
    image: `${BASE}/interfaith-sankalp.jpg`,
    alt: "Leaders from multiple traditions holding plants during an interfaith gathering",
  },
  {
    category: "Global harmony",
    label: "International cultural dialogue",
    image: `${BASE}/mongolia-dialogue.jpg`,
    alt: "Pujya Swami Avdheshanand Giri ji with a delegation outside an international public building",
  },
  {
    category: "Public life",
    label: "The Path to Ananda with Prime Minister Narendra Modi",
    image: `${PUBLIC_LIFE_BASE}/pm-modi-swamiji-book.webp`,
    alt: "Pujya Swami Avdheshanand Giri ji with Prime Minister Narendra Modi holding The Path to Ananda",
  },
  {
    category: "Public life",
    label: "Dialogue with Prime Minister Narendra Modi",
    image: `${PUBLIC_LIFE_BASE}/pm-modi-swamiji-dialogue.jpg`,
    alt: "Pujya Swami Avdheshanand Giri ji in dialogue with Prime Minister Narendra Modi",
  },
  {
    category: "Public life",
    label: "Memento presentation with Prime Minister Narendra Modi",
    image: `${PUBLIC_LIFE_BASE}/pm-modi-swamiji-gift.jpg`,
    alt: "Pujya Swami Avdheshanand Giri ji presenting a memento to Prime Minister Narendra Modi",
  },
  {
    category: "Public life",
    label: "Meeting with the President of India",
    image: `${PUBLIC_LIFE_BASE}/president-of-india-meeting-v2.jpg`,
    alt: "Pujya Swami Avdheshanand Giri ji meeting the President of India",
  },
  {
    category: "Public life",
    label: "Meeting with Uttar Pradesh leadership",
    image: `${PUBLIC_LIFE_BASE}/yogi-adityanath-meeting-v2.jpg`,
    alt: "Pujya Swami Avdheshanand Giri ji with Uttar Pradesh public leadership",
  },
  {
    category: "Public life",
    label: "National leadership dialogue",
    image: `${PUBLIC_LIFE_BASE}/defence-minister-dialogue.jpg`,
    alt: "Pujya Swami Avdheshanand Giri ji in dialogue with national leadership",
  },
  {
    category: "Public life",
    label: "State leadership felicitation",
    image: `${PUBLIC_LIFE_BASE}/state-leadership-felicitation.jpg`,
    alt: "Pujya Swami Avdheshanand Giri ji receiving a public leadership felicitation",
  },
  {
    category: "Public life",
    label: "Public service consultation",
    image: `${PUBLIC_LIFE_BASE}/public-leadership-consultation.jpg`,
    alt: "Pujya Swami Avdheshanand Giri ji reviewing notes with public leadership",
  },
  {
    category: "Public life",
    label: "Community dignitary welcome",
    image: `${PUBLIC_LIFE_BASE}/community-dignitary-welcome.jpg`,
    alt: "Pujya Swami Avdheshanand Giri ji welcomed by community dignitaries",
  },
  {
    category: "Public life",
    label: "Yoga and Ayurveda leadership",
    image: `${PUBLIC_LIFE_BASE}/baba-ramdev-acharya-balkrishna.jpg`,
    alt: "Pujya Swami Avdheshanand Giri ji with yoga and Ayurveda leadership",
  },
  {
    category: "Kumbh leadership",
    label: "Prayagraj Kumbh public leadership presence",
    image: `${PUBLIC_LIFE_BASE}/prayagraj-kumbh-public-leadership-8.jpg`,
    alt: "Pujya Swami Avdheshanand Giri ji with public leaders during Prayagraj Kumbh",
  },
  {
    category: "Kumbh leadership",
    label: "Prayagraj Kumbh civic dialogue",
    image: `${PUBLIC_LIFE_BASE}/prayagraj-kumbh-public-leadership-9.jpg`,
    alt: "Pujya Swami Avdheshanand Giri ji in civic dialogue during Prayagraj Kumbh",
  },
  {
    category: "Kumbh leadership",
    label: "Prayagraj Kumbh dignitary moment",
    image: `${PUBLIC_LIFE_BASE}/prayagraj-kumbh-public-leadership-15.jpg`,
    alt: "Pujya Swami Avdheshanand Giri ji during a dignitary moment at Prayagraj Kumbh",
  },
  {
    category: "Public life",
    label: "Meeting with national leadership",
    image: `${BASE}/president-of-india-meeting.jpg`,
    alt: "Pujya Swami Avdheshanand Giri ji meeting national public leadership",
  },
  {
    category: "Public life",
    label: "Meeting with Uttar Pradesh leadership",
    image: `${BASE}/yogi-adityanath-meeting.jpg`,
    alt: "Pujya Swami Avdheshanand Giri ji with Uttar Pradesh public leadership",
  },
  {
    category: "Lineage",
    label: "Guru-parampara dialogue",
    image: `${BASE}/guru-parampara-bharat-mata-mandir.jpg`,
    alt: "Pujya Swami Avdheshanand Giri ji in a guru-parampara setting",
  },
  {
    category: "Lineage",
    label: "Monastic blessing ceremony",
    image: `${BASE}/monastic-blessing.jpg`,
    alt: "Pujya Swami Avdheshanand Giri ji with saints during a blessing ceremony",
  },
  {
    category: "Lineage",
    label: "Sannyas home, Haridwar",
    image: `${BASE}/sannyas-home-haridwar.jpg`,
    alt: "Sadhus gathered in Haridwar",
  },
  {
    category: "Sacred institutions",
    label: "Kashi sadhu sabha",
    image: `${BASE}/kashi-sadhu-sabha.jpg`,
    alt: "Sadhus gathered in Kashi",
  },
  {
    category: "Sacred institutions",
    label: "Bharat Mata Mandir lineage",
    image: `${BASE}/bharat-mata-mandir-lineage.jpg`,
    alt: "Saints at Bharat Mata Mandir with Pujya Swami Avdheshanand Giri ji",
  },
  {
    category: "Sacred institutions",
    label: "Bharat Mata Mandir gathering",
    image: `${BASE}/bharat-mata-mandir-sadhus.jpg`,
    alt: "Sadhus gathered at Bharat Mata Mandir",
  },
  {
    category: "Pilgrimage",
    label: "Amarnath darshan",
    image: `${BASE}/amarnath-darshan.jpg`,
    alt: "Pujya Swami Avdheshanand Giri ji at Amarnath",
  },
  {
    category: "Pilgrimage",
    label: "Himalayan Mahasamadhi Day",
    image: `${BASE}/himalayan-mahasamadhi-day.jpg`,
    alt: "Mahasamadhi Day event with spiritual leaders",
  },
  {
    category: "Seva",
    label: "Gaushala and dharmic stewardship",
    image: `${BASE}/harihar-gaushala.jpg`,
    alt: "Pujya Swami Avdheshanand Giri ji in a gaushala",
  },
  {
    category: "Seva",
    label: "Healthcare infrastructure guidance",
    image: `${BASE}/hospital-equipment-guidance.jpg`,
    alt: "Pujya Swami Avdheshanand Giri ji with healthcare equipment",
  },
];
